import { useNavigate, useParams } from 'react-router-dom';
import { Alert } from '@mui/material';
import {
  useGetAllPropertyMappingsForCogoPoint,
  useGetCogoPointSetting,
  useUpdatePropertyMappingsForCogoPoint,
} from '../../../hooks/api/use-arcgis-civil3d-cogo-point-settings.hook';
import {
  ArcgisCivil3dCogoPointSettingApiModel,
  ArcgisCivil3dCogoPointSettingRelationship,
} from '../../../../../types/models/arcgis-civil3d-cogo-point-setting.model';
import { PropertyMappings } from './PropertyMappings';
import { LoadingIndicator } from '../../LoadingIndicator';
import { Civil3dFeatureTypeCategory } from '../../../../../types/constants/civil3d-feature-type';
import { WithConfiguration } from '../../../../../types/models/arcgis-civil3d-setting.model';

export const CogoPointPropertyMappings = () => {
  const navigate = useNavigate();
  const { cogoPointId } = useParams<{ cogoPointId: string }>();

  const [updatePropertyMappings, { error: updatePropertyMappingsError }] = useUpdatePropertyMappingsForCogoPoint();
  const {
    cogoPoint,
    loading: loadingCogoPoint,
    error: getCogoPointError,
  } = useGetCogoPointSetting<ArcgisCivil3dCogoPointSettingApiModel & WithConfiguration>({
    cogoPointId: Number(cogoPointId),
    include: [ArcgisCivil3dCogoPointSettingRelationship.CONFIGURATION],
  });
  const {
    propertyMappings,
    loading: loadingPropertyMappings,
    error: propertyMappingsError,
  } = useGetAllPropertyMappingsForCogoPoint({
    cogoPointId: Number(cogoPointId),
  });
  const error = getCogoPointError || propertyMappingsError || updatePropertyMappingsError;
  if (error) {
    return <Alert severity="error">{error.response?.data.message}</Alert>;
  }

  return loadingCogoPoint || loadingPropertyMappings || !cogoPoint || !propertyMappings ? (
    <LoadingIndicator />
  ) : (
    <PropertyMappings
      settingName={cogoPoint?.name}
      templateId={cogoPoint?.configuration.template.id}
      featureClassId={cogoPoint?.arcgisFeatureClass.id}
      isMappingDefaults
      featureTypeCategoryName={Civil3dFeatureTypeCategory.COGO_POINT}
      propertyMappings={propertyMappings}
      onSave={async ({ propertyMappings: propertyMappingsToSave }) => {
        await updatePropertyMappings({
          cogoPointId: Number(cogoPointId),
          propertyMappings: propertyMappingsToSave.filter(({ attributeId }) => Boolean(attributeId)),
        });
        navigate('..');
      }}
    ></PropertyMappings>
  );
};
